import PageTemplate from '../../components/ui/PageTemplate';
import useObserver from '../../hooks/page/useObserver';
import STAI from './STAI';
import Voronoi from './Voronoi';

const Technology = () => {
  useObserver(
    'content-Technology',
    'content-Technology-tablet',
    'content-Technology-desktop'
  );

  return (
    <PageTemplate id='Technology'>
      {/* Mobile Layout */}
      <div
        id='content-Technology'
        className='md:hidden flex w-full min-h-screen bg-cover bg-center bg-no-repeat relative'
        style={{ backgroundImage: "url('/redesign/BG_Technology.png')" }}
      >
        <div className='w-full max-w-[360px] mx-auto py-20 flex flex-col gap-10 relative z-10'>
          <div className='relative z-20 flex flex-col gap-10 px-4'>
            <h1 className='text-[20px] font-semibold text-[#FFFFFF]'>
              Technology
            </h1>
            <div className='w-full flex flex-col gap-20'>
              <STAI />
              <Voronoi />
            </div>
          </div>
        </div>
      </div>

      {/* Tablet Layout */}
      <div
        id='content-Technology-tablet'
        className='hidden md:flex xl:hidden w-full min-h-screen bg-cover bg-center bg-no-repeat relative'
        style={{ backgroundImage: "url('/redesign/BG_Technology.png')" }}
      >
        <div className='w-full max-w-[688px] mx-auto flex flex-col justify-start items-start py-36 gap-32 relative z-10'>
          <div className='relative z-20 flex flex-col gap-[120px]'>
            <div className='flex flex-col'>
              <h1 className='text-[30px] font-semibold text-[#FFFFFF]'>
                Technology
              </h1>
            </div>
            <STAI />
            <Voronoi />
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Technology-desktop'
        className='hidden xl:flex w-full min-h-screen bg-cover bg-center bg-no-repeat relative'
        style={{ backgroundImage: "url('/redesign/BG_Technology.png')" }}
      >
        <div className='w-full max-w-[1060px] mx-auto min-h-full flex flex-col justify-start items-start py-36 gap-32 relative z-10'>
          <div className='relative z-20 flex flex-col gap-24'>
            <div className='flex flex-col'>
              <h1 className='text-[28px] font-semibold text-[#FFFFFF]'>
                Technology
              </h1>
            </div>
            <STAI />
            <Voronoi />
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Technology;
